
import notFound from '@/assets/404/404.png';
import cloud from '@/assets/404/404_cloud.png';

export default {
  data: function data() {
    return {
      notFound: notFound,
      cloud: cloud
    };
  },

  computed: {
    message: function message() {
      return '特朗普说这个页面你不能进......';
    }
  }
};